<template>
    <div class="relative pb-5">
        <div class="wrapper-input relative border border-a-brown-d7c7b8 rounded-10 bg-white overflow-hidden">
            <input type="text"
                :id="inputId"
                class="w-full text-14 px-3.5 pt-6 font-main text-a-brown-502314"
                v-model="content"
                :maxlength="inputMaxLength"
                @input="onChange()"
                @focus="onFocus(true)"
                @blur="onFocus(false)">
            <label :for="inputId"
                class="block absolute px-3.5 text-a-brown-9f8273 duration-300"
                :class="[{'top-3.5 px-3.5 text-14': !content && !focusText},
                        {'top-1.5  text-12': content || focusText},
                        ]"
            ><span v-if="inputLbl.required" class="text-a-red-d62300">*</span>{{inputLbl.name}}</label>
        </div>
        <div class="text-red-500 text-sm absolute bottom-0 left-0 w-full" v-if="isError">
            {{getErrorMsg}}
        </div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import RegxHelper from "@/helper/RegxHelper.js";

/**
 * @property {String} v-model:inputValue (required) bind value
 * @property {Number} minLength (optional) Minimum length.
 * @property {Number} maxLength (optional) Maximum Length.
 * @property {Object} errorInfo (required) Validate result. example : { isValid: true, msg: '',}
 * @property {Boolean} isShowError (optional) Show/Hide Error label.
 * @property {Boolean} isSubmitted (optional) Show/Hide Error after save.
 * @property {Object} inputLbl (required) Text for component.
 */
export default {
    name: "InputEmail",
    props: {
        // v-model
        inputValue:     { type: String },
        // props
        minLength:      { type: Number },
        maxLength:      { type: Number, default: 0 },
        errorInfo:      { type: Object, required: true },
        isShowError:    { type: Boolean, default: false },
        isSubmitted:    { type: Boolean, default: false },
        // text
        inputLbl:       { type: Object, required: true },
    },
    computed: {
        isError: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid);
        },
        getErrorMsg: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid)
                ? this.errorInfo.msg
                : '';
        }
    },
    data: function() {
        return {
            inputId: '',
            content: this.inputValue,
            inputMaxLength: null,
            focusText: false,
        };
    },
    created: function () {
        let randId = Math.floor(Math.random() * 100000);
        this.inputId = 'contact-number-' + randId;

        if (this.maxLength > 0) {
            this.inputMaxLength = this.maxLength;
        }
    },
    mounted: function() {
        this.validateInput();
    },
    methods: {
        validateInput: function () {
            if (!this.inputLbl) {
                return;
            }
            // set default.
            this.errorInfo.setValid(true);
            this.errorInfo.setMsg('');
            // required
            if (this.inputLbl.required
                && !this.content) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(this.inputLbl.required)
                return;
            }
            // too short
            if (this.inputLbl.too_short && this.content && this.minLength
                && (this.content.length < this.minLength)) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(Util.stringFormat(this.inputLbl.too_short, this.minLength));
                return;
            }
            // invalid format
            if (this.inputLbl.invalid && this.content) {
                if (!RegxHelper.isEmailFormat(this.content)) {
                    this.errorInfo.setValid(false);
                    this.errorInfo.setMsg(this.inputLbl.invalid);
                    return;
                }
            }
        },
        onChange: function() {
            let result = this.content;

            this.validateInput();
            this.$emit('update:inputValue', result);
        },
        onFocus: function(focus) {
            this.focusText = focus;
        },
    },
}
</script>
<style lang="scss" scoped>
    .wrapper-input {
        height: 50px;
    }
</style>
